import React, { useEffect } from "react";

export default function useOnClickOutside(ref: any, handler: any) {
	useEffect(
		() => {
			const listener = (event: any) => {
				// Do nothing if clicking ref's element or descendent elements
				if (!ref?.current || ref?.current.contains(event.target)) {
					return;
				}
				
				// Prevent closing if clicking on form elements or interactive elements
				const target = event.target as HTMLElement;
				if (target.tagName === 'INPUT' || 
					target.tagName === 'TEXTAREA' || 
					target.tagName === 'SELECT' || 
					target.tagName === 'BUTTON' ||
					target.closest('form') ||
					target.closest('[role="button"]') ||
					target.closest('[data-modal-content]')) {
					return;
				}
				
				handler(event);
			};
			document.addEventListener("mousedown", listener);
			document.addEventListener("touchstart", listener);
			return () => {
				document.removeEventListener("mousedown", listener);
				document.removeEventListener("touchstart", listener);
			};
		},
		// Add ref and handler to effect dependencies
		// It's worth noting that because passed in handler is a new ...
		// ... function on every render that will cause this effect ...
		// ... callback/cleanup to run every render. It's not a big deal ...
		// ... but to optimize you can wrap handler in useCallback before ...
		// ... passing it into this hook.
		[ref, handler]
	);
}
